import React, { Component } from 'react';
import { Button } from 'antd';
import {
  getDataPhuong,
  getDataQuan,
} from '../../../redux/actions/search.action';
import { connect } from 'react-redux';
import { AxiosGetSecretApi } from '../../../utils/fetchApi';
import StaticClass from '../../../utils/staticClass';
class ThongTinDuAn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data10000: {},
    };
    this.TitleDuAn = [
      'Tên dự án',
      'Quận/Huyện',
      'Phường/Xã',
      'Chủ đầu tư',
      'Diện tích (ha)',
      'Điều hành dự án',
    ];

    this.ValueDuAn = [
      'Tendoan',
      'TenPhuong',
      'TenPhuong',
      'Chudautu',
      'DienTich',
      'Dieuhanhduan',
    ];

    this.TitleDuAn5000 = [
      'Mã phân khu',
      'Tên phân khu',
      'Mã quy hoạch chung',
      'Diện tích (ha)',
    ];

    this.ValueDuAn5000 = ['MaPhanKhu', 'TenPhanKhu', 'MaQHChung', 'DienTich'];

    this.TitleDuAn10000 = [
      'Năm quy hoạch',
      'Số quyết định',
      'Ngày ra quyết định',
    ];

    this.ValueDuAn10000 = ['NamQH', 'QuyetDinh', 'NgayRaQD'];
  }

  componentDidMount() {
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    if (this.props.listPhuong.length === 0) this.props.getDataQuan();

    this.getPhuong();
    if (this.props.type === 'QHCT' && this.props.data) {
      if (this.props.data.Madoan) {
        this.getDataDuAnChiTiet(this.props.data.Madoan);
      }
      if (this.props.data.OBJECTID_1) {
        this.getGeoDataQHCT(this.props.data.OBJECTID_1);
      }
    }

    if (
      this.props.type === 'QHPK' &&
      this.props.data &&
      this.props.data.OBJECTID
    ) {
      this.getGeoDataQHPK(this.props.data.OBJECTID);
    }

    if (this.props.type === 'QHC') {
      this.getDataQHC();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.getPhuong();
      if (this.props.type === 'QHCT' && this.props.data) {
        if (this.props.data.Madoan) {
          this.getDataDuAnChiTiet(this.props.data.Madoan);
        }
        if (this.props.data.OBJECTID_1) {
          this.getGeoDataQHCT(this.props.data.OBJECTID_1);
        }
      }

      if (
        this.props.type === 'QHPK' &&
        this.props.data &&
        this.props.data.OBJECTID
      ) {
        this.getGeoDataQHPK(this.props.data.OBJECTID);
      }
    }

    if (prevProps.type !== this.props.type) {
      if (this.props.type === 'QHC') {
        this.getDataQHC();
      }
    }

    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
      this.getPhuong();
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
      this.getPhuong();
    }
  }

  getPhuong = () => {
    this.props.listPhuong.forEach((e) => {
      if (this.props.data && this.props.data.Maphuong === e.MaPhuong) {
        this.setState({ phuong: e.TenPhuong });
        this.props.listQuan.forEach((o) => {
          if (o.MAHUYEN === e.MaQuan) {
            this.setState({
              quan: o.TENHUYEN,
            });
            return;
          }
        });
      }
    });
  };

  async getDataDuAnChiTiet(id) {
    let data = this.props.data;
    let res = await AxiosGetSecretApi(
      `/api/duanqh/search?curPage=1&pageSize=10&OBJECTID=${id}`
    );
    if (
      res &&
      res.dataResult &&
      Array.isArray(res.dataResult) &&
      res.dataResult.length > 0
    ) {
      data = res.dataResult[0];
    }

    this.setState({
      dataChiTiet: data,
    });
  }

  getGeoDataQHCT = async (id) => {
    let url = `/api/duanqh/search?curPage=1&pageSize=10&&OBJECTID=${id}`;
    let res = await AxiosGetSecretApi(url);
    if (res && res.dataResult && res.dataResult.length !== 0) {
      let idRing = res.dataResult[0].OBJECTID_1;
      let resRing = await AxiosGetSecretApi(
        `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/7/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${idRing}&outFields=*&outSR=102100`
      );
      if (
        resRing &&
        resRing.features &&
        Array.isArray(resRing.features) &&
        resRing.features.length !== 0 &&
        resRing.features[0].geometry &&
        resRing.features[0].geometry.rings
      )
        this.props.drawRing(resRing.features[0].geometry.rings);
    }
  };

  getGeoDataQHPK = async (id) => {
    let url = `/api/qh-phan-khu/search?curPage=1&pageSize=10&OBJECTID=${id}`;
    let res = await AxiosGetSecretApi(url);
    if (res && res.dataResult && res.dataResult.length !== 0) {
      let idRing = res.dataResult[0].OBJECTID;
      let resRing = await AxiosGetSecretApi(
        `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/8/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${idRing}&outFields=*&outSR=102100`
      );
      if (
        resRing &&
        resRing.features &&
        Array.isArray(resRing.features) &&
        resRing.features.length !== 0 &&
        resRing.features[0].geometry &&
        resRing.features[0].geometry.rings
      )
        this.props.drawRing(resRing.features[0].geometry.rings);
    }
  };

  async getDataQHC() {
    if (!this.state.data10000.NamQH) {
      let res = await AxiosGetSecretApi('/api/qh-chung/getAllNamQH');
      if (res && res.length !== 0) {
        let data = {
          ...res[0],
          NgayRaQD: res[0].NgayRaQD
            ? StaticClass.formatDate(res[0].NgayRaQD)
            : res[0].NgayRaQD,
        };
        this.setState({
          data10000: data,
        });
      }
    }
  }

  render() {
    return (
      <div>
        <div className='map-info-popup'>
          <div className='title'>
            Thông tin dự án
            <i class='fas fa-times close-icon' onClick={this.props.onClose}></i>
          </div>

          {this.props.type === 'QHCT' && (
            <div className='body'>
              {this.TitleDuAn.map((e, i) => (
                <div style={{ display: 'flex' }}>
                  <div className='left'>{e}:</div>
                  <div className='right'>
                    {this.state.dataChiTiet
                      ? i === 1
                        ? this.state.quan
                        : i === 2
                        ? this.state.phuong
                        : i === 4
                        ? StaticClass.formatPrice(
                            this.state.dataChiTiet[`${this.ValueDuAn[i]}`]
                          )
                        : this.state.dataChiTiet[`${this.ValueDuAn[i]}`]
                      : '-'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {this.props.type === 'QHPK' && (
            <div className='body'>
              {this.TitleDuAn5000.map((e, i) => (
                <div style={{ display: 'flex' }}>
                  <div className='left'>{e}:</div>
                  <div className='right'>
                    {this.props.data
                      ? this.props.data[`${this.ValueDuAn5000[i]}`] &&
                        this.props.data[`${this.ValueDuAn5000[i]}`] !==
                          'null' &&
                        this.props.data[`${this.ValueDuAn5000[i]}`] !== 'Null'
                        ? i === 3
                          ? StaticClass.formatPrice(
                              this.props.data[`${this.ValueDuAn5000[i]}`]
                            )
                          : this.props.data[`${this.ValueDuAn5000[i]}`]
                        : '-'
                      : '-'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {this.props.type === 'QHC' && (
            <div className='body'>
              {this.TitleDuAn10000.map((e, i) => (
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      minWidth: '130px',
                      maxWidth: '130px',
                      marginRight: '10px',
                    }}
                  >
                    {e}:
                  </div>
                  <div className='right'>
                    {this.state.data10000[`${this.ValueDuAn10000[i]}`]
                      ? this.state.data10000[`${this.ValueDuAn10000[i]}`]
                      : '-'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {this.props.isShowGroupButton && (
            <div className='footer'>
              <Button
                className='button'
                type='primary'
                onClick={this.props.onFullMap}
              >
                Xem đầy đủ
              </Button>
              <Button
                className='button'
                type='primary'
                onClick={this.props.onDownload}
              >
                Tải bản đồ
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    listPhuong: state.search.listPhuong,
    listQuan: state.search.listQuan,
  };
};

const mapDispatchToProps = {
  getDataPhuong: getDataPhuong,
  getDataQuan: getDataQuan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThongTinDuAn);
